// src/pages/InfoComercios.jsx
import React from "react";

const InfoComercios = () => {
  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Información para Comercios</h1>
      <p className="text-secondary">
        Todo lo que necesitás saber para ofrecer beneficios de forma simple.
      </p>

      <h4 className="fw-bold mt-4">¿Qué es QRBenefits?</h4>
      <p>Una plataforma que conecta comercios y clientes mediante beneficios reales.</p>

      <h4 className="fw-bold mt-4">¿Cómo funciona?</h4>
      <p>Creás un beneficio, imprimís tu QR y tus clientes comienzan a usarlo.</p>

      <h4 className="fw-bold mt-4">Reseñas y puntuación</h4>
      <p>Los clientes pueden dejar reseñas que te ayudan a mejorar y posicionarte.</p>
    </div>
  );
};

export default InfoComercios;
